/**
 * Defines comparison operators used on the query in filter buttons.
 */

export const FilterType = {
    Equal: '=',
    NotEqual: '<>',
    Greater: '>',
    Smaller: '<',
    Contains: 'contains',
    Like: 'like',
    StartsWith: 'startsWith',
    GreaterEqual: '>=',
    SmallerEqual: '<=',
};